import { useState, useEffect } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion } from '@mui/material'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import { bool, func } from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { CvsChipInput } from '@components'
import { LinkPreview } from './link-preview'
import { Parameters } from './parameters'
import * as TemplateActions from '../template.actions'
import { EncodingOptions } from './encoding-options'
import { t } from '@lingui/core/macro'

export const UrlConstruction = ({ isOpen = false, resetIsOpen = () => false }) => {
  const [expanded, setExpanded] = useState(isOpen)
  const dispatch = useDispatch()
  const domains = useSelector(state =>
    Object.values(state.Template.templateFieldsById)
      .find(tf => tf.governance_type === 'link')
      .field.link_governance.domain_restrictions.map(dr => dr.domain || dr),
  )

  useEffect(() => {
    isOpen && setExpanded(true)
  }, [isOpen])

  const handleChange = newVal => {
    dispatch(TemplateActions.setDomains(newVal))
  }

  const manualParameters = useSelector(state => state.Auth.features['allow-redirect-links'])

  return (
    <>
      <Accordion
        expanded={expanded}
        onChange={() => {
          resetIsOpen()
          setExpanded(!expanded)
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div>
            <Typography>{t`Customize link parameters`}</Typography>
            <LinkPreview />
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ width: '100%' }}>
            {manualParameters && <EncodingOptions />}
            <Parameters />
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div>
            <Typography>{t`Allowed domains`}</Typography>
            <Typography variant="caption">
              {t`Restrict the domains that can be used with this template. If no restriction is added, this template can be used with any domain.`}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ width: '100%' }}>
            <CvsChipInput
              value={domains}
              onChange={handleChange}
              label={t`Domains`}
              placeholder={t`(enter)`}
            />
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

UrlConstruction.propTypes = {
  isOpen: bool,
  resetIsOpen: func,
}
